import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'realName', label: '教师姓名', width: 100},
    {key:'superOrgName', label: '二级部门', width: 140},
    {key:'orgName', label: '部门', width: 140},
    {key:'evalName1', label: '测评方 1'},
    {key:'evalScore1', label: '测评分数'},
    {key:'evalWeight1', label: '权重'},
    {key:'realScore1', label: '实际得分'},
    {key:'grade1', label: '等级'},

    {key:'finalScore', label: '最终测评分',  width: 115},
    {key:'finalGradeAll', label: '综合等级',  width: 115},
    {key:'finalGrade', label: '最终等级',  width: 115},
    {key:'termName', label: '学期',  width: 80},
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)

    return fetch.post('eval/allTermTime/query?'+ params.join('&'), Object.assign(defaultsParams, keywords))
    .then(response => {
        const columns = [
            {type: 'selection'},
            {key:'$index', label: '序号', width: 75},
            {key:'superOrgName', label: '二级部门', width: 140},
            {key:'orgName', label: '部门名称', width: 150},
            {key:'employeeName', label: '教师姓名', width: 90},
            {key:'employeeCode', label: '教师编号', width: 90},
            {key:'teacherPropertyName', label: '教师性质', width: 90},
            {key:'descContent', label: '描述', width: 90},
            {key:'finalScore', label: '最终测评分', width: 110},
            {key:'finalGradeAll', label: '综合等级', width: 90},
            {key:'finalGrade', label: '最终等级', width: 90},
            {key:'termName', label: '学期', width: 130}
        ];

        (response.payload.meta.extParams.evalNameList||[]).forEach((list , index) => {
            const evalName = list
            if(evalName){
                columns.push({key:'evalScore'+ (index+1), label: `${evalName}`, width: 110});
                // columns.push({key:'evalScore'+ (index+1), label: '测评分数', width: 90});
                columns.push({key:'evalWeight'+ (index+1), label: '权重', width: 70});
                columns.push({key:'realScore'+ (index+1), label: '实际得分', width: 90});
                columns.push({key:'grade'+ (index+1), label: '等级', width: 70});
            }
        });

        return {
            headers: utils.columns(columns),
            data: response.payload.data
        };
    })
    .then(response => {
        
        return Object.assign({
            headers: response.headers,
            result: response.data.dataList || [],
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                key: d.id,
                checked: false
            })),
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })
    });
}

/**
 * 清空本学期汇总数据
 */
const removeAllData = (keywords = {}) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                fetch.post('eval/allTermTime/remove', keywords)
                .then((response) => {
                    if(response.code === 200) {
                        message.success(`共删除${response.payload.data}条记录`);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                        resolve(true);
                    } else {
                        reject();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    })
}

/** 
 * 计算最终等级
*/
const gradeCount = (keywords = {}) => {
    return new Promise(function(resolve, reject) {
        fetch.post('eval/allTermTime/countFinalGradeByTerm', keywords)
        .then((response) => {
            if(response.code === 200) {
                message.success(response.message);
                resolve(true);
            } else {
                reject()
            }
        });
    })
}

/** 
 * 查询单条数据
 */
const querySearchById = (id) => {
    return new Promise(function(resolve, reject) {
        fetch.get('eval/allTerm/get/'+ id)
        .then((response) => {
            if(response.code === 200) {
                resolve(response.payload.data);
            } else {
                reject()
            }
        });
    })
}

/**
 * 更新单条数据
 */
const update = (id, data) => {
    return fetch.post('eval/allTerm/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到管理页面！</p>
                    </div>
                ),
                onOk() {
                    window.location.hash = 'mulEval/listTotalByEmpTerm/index';
                },
            });
        }
    });
}

/**
 * 删除数据
 */
const remove = (ids) => {
    return fetch.post('eval/allTerm/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'mulEval/listTotalByEmpTermEx'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    update,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    removeAllData,
    gradeCount,
    getSelection,
    querySearchById
}